import React from 'react';
import styles from './PageTemplateModal.module.css';

const EmptyTemplateSearchResult = () => (
  <div className={styles.emptySearchContainer}>
    <div className={styles.emptySearchHeader}>
      Looks like we do not have a template for that&#8230; yet!
    </div>
    <div className={styles.emptySearchBody}>
      We are always looking for new ideas.
      <br />
      Get in touch and let us know what you are looking for!
    </div>
    <aha-button
      style={{
        display: 'flex',
        alignItems: 'center',
        width: '30%',
        maxWidth: '145px',
        height: '32px',
        cursor: 'pointer',
        boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.08)',
        fontSize: '14px',
        lineHeight: '14px',
      }}
      kind='primary'
      onClick={() => {
        try {
          window.ahaFeedbackWidget('open', '7156403201117059215');
        } catch (error) {
          window.open(
            'https://big.ideas.aha.io/',
            '_blank',
            'noopener,noreferrer'
          );
        }
      }}
    >
      Request template
    </aha-button>
  </div>
);

export default EmptyTemplateSearchResult;
